import { createReducer } from 'redux-act';

const initialState = {
  fullscreen_index: 0
};

export const gallery = createReducer<any>({}, initialState);

gallery.on('set_current_gallery', (state, payload: any) => ({ ...state, currentGallery: payload }));
